<header matDialogTitle>
  <div>{{ mode }} deposit instruction</div>
  <button mat-icon-button color="primary" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</header>
<form [formGroup]="form" matDialogContent>
  <mat-form-field appearance="outline">
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" appAutofocus />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Name for client</mat-label>
    <input matInput formControlName="nameForClient" />
  </mat-form-field>
  <app-asset-filter [options]="assets()" formControlName="asset"></app-asset-filter>
  <app-business-entity-selector
    formControlName="businessEntity"
    [required]="true"
    [readOnly]="mode === 'Update'"
  ></app-business-entity-selector>
  @for (dataItem of form.controls.data.controls; track dataItem; let i = $index) {
    <div class="row" [formGroup]="dataItem">
      <mat-form-field appearance="outline">
        <mat-label>Label</mat-label>
        <input matInput formControlName="key" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Value</mat-label>
        <input matInput formControlName="value" />
      </mat-form-field>
      <button
        [disabled]="form.controls.data.controls.length === 1"
        (click)="remove(i)"
        class="remove-action"
        color="accent"
        mat-icon-button
        type="button"
      >
        <mat-icon svgIcon="delete" color="err-primary"></mat-icon>
      </button>
    </div>
  }
  <button mat-button color="primary" class="action-button" type="button" (click)="add()">
    <mat-icon>add</mat-icon>
    <span>Add item</span>
  </button>
</form>
<div matDialogActions>
  <button [disabled]="form.invalid || form.pristine" mat-raised-button color="primary" type="button" (click)="submit()">
    {{ mode }}
  </button>
  <button mat-button type="button" color="primary" matDialogClose>Cancel</button>
</div>
